// ANCHOR React
import { memo } from 'react';

// ANCHOR Components
import { LyonContentCards } from '@lyon/components/content/LyonContentCards';
import { LyonCourseCardRevision } from '../LyonCourseCard';

interface IProps {
  fromHomePage?: boolean;
}

export const LyonCourseCardSkeleton = memo(({ fromHomePage }: IProps) => (
  <LyonContentCards layout="column" fromHomePage={fromHomePage}>
    <LyonCourseCardRevision />
    <LyonCourseCardRevision />
    <LyonCourseCardRevision />
    <LyonCourseCardRevision />
  </LyonContentCards>
));
